"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.StateProvider = void 0;
const tslib_1 = require("tslib");
/* exports all storefront effects so they can be used in the project */
const effects_1 = tslib_1.__importDefault(require("./effects"));
/**
 * Pass down the storefront recoil hooks to the project
 * so that they can be in the same shared recoil instance
 */
const store_1 = tslib_1.__importStar(require("./store"));
var StateProvider_1 = require("./StateProvider");
Object.defineProperty(exports, "StateProvider", { enumerable: true, get: function () { return StateProvider_1.StateProvider; } });
/* eslint-disable import/export */
tslib_1.__exportStar(require("./hooks"), exports); // These hooks will be the default hooks found in @backpackjs/storefront
exports.store = {
    state: store_1.default,
    effects: effects_1.default,
    recoil: {
        useRecoilState: store_1.useRecoilState,
        useRecoilStateLoadable: store_1.useRecoilStateLoadable,
        useSetRecoilState: store_1.useSetRecoilState,
        useResetRecoilState: store_1.useResetRecoilState,
        useRecoilValue: store_1.useRecoilValue,
        useRecoilValueLoadable: store_1.useRecoilValueLoadable,
        useRecoilSnapshot: store_1.useRecoilSnapshot,
        useRecoilCallback: store_1.useRecoilCallback,
        atom: store_1.atom,
        atomFamily: store_1.atomFamily,
        selector: store_1.selector,
        selectorFamily: store_1.selectorFamily,
    },
};
//# sourceMappingURL=index.js.map